<template lang="html">
     <Swiper :imgs="goods_imgs_url" :actSrc="activity_tag_img" :isShowSkuPic="true" />
</template>
<style>
</style>
<script>
import Swiper from '@/components/swiper/swiper.tpl.vue'
export default {
    props: {
        goods_imgs_url : {
            type: Array,
            required: true,
            default () {
                return []
            }
        },
        activity_tag_img: {
            type: String,
            required: true,
            default () {
                return ''
            }
        }
    },
    name: 'goodsSwiper',
    components: {
        Swiper
    }
}
</script>
